import React from "react";
import styled from "styled-components";
import { useTheme } from "../../middleware/ThemeContext";
import { Theme } from "../../utils/themes";

interface StyledSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  thumbSize?: number;
  width?: number;
  height?: number;
  switchColor?: string;
}

const SwitchWrapper = styled.div<{
  checked: boolean;
  $width: number;
  $height: number;
  $switchColor: string;
}>`
  width: ${({ $width }) => `${$width}px`};
  height: ${({ $height }) => `${$height}px`};
  border-radius: 9999px;
  background-color: ${({ checked, $switchColor }) => (checked ? $switchColor : "#ccc")};
  display: flex;
  align-items: center;
  padding: 2px;
  cursor: pointer;
  transition: background-color 0.3s ease;
`;

const Thumb = styled.div<{
  checked: boolean;
  $thumbSize: number;
  $translateX: number;
  theme: Theme;
}>`
  width: ${({ $thumbSize }) => `${$thumbSize}px`};
  height: ${({ $thumbSize }) => `${$thumbSize}px`};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.CorporateTheme.colors.background};
  transition: transform 0.3s ease;
  transform: ${({ checked, $translateX }) =>
    checked ? `translateX(${$translateX}px)` : "translateX(0)"};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

const StyledSwitch: React.FC<StyledSwitchProps> = ({
  checked,
  onChange,
  thumbSize = 17,
  width = 43,
  height = 20,
  switchColor = "#003366",
}) => {
  const translateX = Math.max(width - thumbSize - 4, 0);
  const { theme } = useTheme();
  return (
    <SwitchWrapper
      checked={checked}
      $width={width}
      $height={height}
      $switchColor={switchColor}
      onClick={() => onChange(!checked)}
    >
      <Thumb checked={checked} $thumbSize={thumbSize} $translateX={translateX} theme={theme}/>
    </SwitchWrapper>
  );
};

export default StyledSwitch;
